/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Refresh: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.7105 2.38611C12.0496 1.95016 12.6779 1.87162 13.1138 2.21069L17.6139 5.71069C17.8575 5.90015 17.9999 6.19146 17.9999 6.50005C17.9999 6.80864 17.8575 7.09995 17.6139 7.2894L13.1138 10.7894C12.6779 11.1285 12.0496 11.0499 11.7105 10.614C11.3715 10.178 11.45 9.54976 11.886 9.21069L14.0854 7.50005H11.5C7.91015 7.50005 5 10.4102 5 14.0001C5 17.5899 7.91014 20.5 11.5 20.5C15.0898 20.5 17.9999 17.5899 17.9999 14C17.9999 13.4478 18.4476 13 18.9999 13C19.5522 13 19.9999 13.4478 19.9999 14C19.9999 18.6944 16.1944 22.5 11.5 22.5C6.80556 22.5 3 18.6945 3 14.0001C3 9.30565 6.80557 5.50005 11.5 5.50005H14.0854L11.886 3.7894C11.45 3.45033 11.3715 2.82206 11.7105 2.38611Z'
      fill='currentColor'
    />
  </React.Fragment>
)
